function startView(id,props) {
	this.ident = id;
	this.properties = props;
	
	swipe = new swiper();
	
	$("#info").hide();
}

startView.prototype = {
	rx: 0,
	ry: 0,
	inX: 0,
	inY: 0,
	panning:false,
	swipe:{},
	pd:null,
	gps:null,
	title:null,
	ia:null,
	wwidth:0,
	wheight:0,
	isStart:false,
	layers:[],
	
	load: function() {
		this.loadQuality(764);
	},

	reorient: function() {
		/*
		var ww = $(window).width();
		var wh = $(window).height();
		var ny;
		var nx;
		var nh;
		var ow;
		var oh;
		
		this.wwidth = ww;
		this.wheight = wh;

		//if (ww * 0.5 < wh) {
		ow = ia.width;
		oh = ia.height;
		
		if (!this.isStart && player.currentView.properties.properties != undefined && player.currentView.properties.properties.layers_mode == "1") {				
			if (ww > wh) {
				ia.width = ww;
				nw = ww;
				nh = oh * (ia.width / ow); 
				ia.height = nh;			
			} else {
				ia.height = wh;
				nh = wh;
				nw = ow * (ia.height / oh); 
				ia.width = nw;							
			}
		} else {
			ia.width = ww;
			nh = oh * (ia.width / ow); 
			ia.height = nh;			
		}
		
		ny = (wh * 0.5) - Math.round(nh * 0.5);
		if (ny < 0) ny = 0;
		
		nx = (ww * 0.5) - Math.round(nw * 0.5);
		if (nx < 0) nx = 0;		
		
		pd.css("top",ny + "px");
		pd.css("left",nx + "px");
				
		if (wh > ww && ny > 100) {
			title.show();
			gps.show();
			
			gps.css("top",ny + ia.height + "px");
			//gps.css("top","700px");			
			
			var ty = ny * 0.5 - title.height() * 0.5;
			title.css("top", ty + "px");
		
		} else {
			title.hide();
			gps.hide();
		}
		
				var ww = $(window).width();
				var wh = $(window).height();
				
				if (!this.isStart) {
					for(layerno in this.layers) {					
						var nw = -1;
						
						
						var layer = this.layers[layerno];
						
						var limg = layer.children("img").get(0);
						
						if (limg.naturalWidth > ww * 0.6) {
							limg.width = ww * 0.6;
							nw = limg.width;
						}
								
						if (limg.naturalHeight > wh * 0.6) {
							limg.height = wh * 0.6;
							if (nw > -1) {									
								limg.width = limg.naturalWidth * (limg.height / limg.naturalHeight);
								if (limg.width > ww * 0.6) {
									limg.width = ww * 0.6;
									nw = limg.width;
									limg.height = limg.naturalHeight * (limg.width / limg.naturalWidth);
								}
							}								
						}
								
						var cx = ww * 0.5 - limg.width * 0.5;
						var cy = wh * 0.5 - limg.height * 0.5;
																
						layer.css("transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
						layer.css("-webkit-transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
											
					};
				};
		*/
	},
	
	loadQuality: function(q) {
		ia = new Image();
		
		this.isStart = true;
		ia.src = this.properties.image;
		
		var self = this;
		
		ia.onload = function() {
			var txt;
		
			//pd = $("<div style='position:absolute;'></div>");
			
			//gps = $("<div style='position:absolute;right:10px;padding-top:8px;color:#ffffff;z-index:9999;'>N " + player.currentView.properties.gps_x + "&deg;<br>E " + player.currentView.properties.gps_y + "&deg;</div>");
			
			if (player.currentView.properties.folder.parent_folder.parent_folder != null) txt = player.currentView.properties.folder.parent_folder.parent_folder.city_name + " - ";
			else txt = "";
			
			txt += player.currentView.properties.folder.parent_folder.city_name;
			
			//title = $("<div style='position:absolute;top:25px;color:#ffffff;z-index:9999;text-align:center;width:100%;'><h1 style='font-size:30px;'>" + player.currentView.properties.folder.city_name + "</h1>" + txt + "</div>");
			
			var ww = $(window).width();
			var wh = $(window).height();
			
			//var mobi = self.properties.image;

			mobi = "/data/" + player.currentView.properties.place_id + "_mobi.jpg";

			var params = {
				"city"		: player.currentView.properties.folder.city_name,
				"title"		: txt,
				"image"		: mobi,
				"ident"		: PROJECT.settings['core/start_pano'], // "75699",
				"angle"		: PROJECT.settings['core/start_pano_look'] // "270"
//				"ident"		: player.currentView.properties.properties.ident_mobi, // "75699",
//				"angle"		: player.currentView.properties.properties.angle_mobi // "270"
			}

			$("#player").css("background-color","#000000");
			$("#player").html("");
			
			$("#player").html(TPL.render("start-template", params));

			if (Autoplay.running()) {
				$(".start_button").hide();
				AppEvent.on(Autoplay, "AUTOPLAY.FINISHED", function() {
					$(".start_button").show();
				});
			}

			AppEvent.trigger(player, "PLACE.LOADED", player.currentView);
			
			player.currentView.reorient();

			self.transitionIn();
		}
	},

	transitionIn: function() {
		var showup = true;

		try {

				setTimeout(function() {$(".startview").css("opacity", "1");}, 50);
				setTimeout(function() {$(".startview h1").css("opacity", "1");}, 500);
				setTimeout(function() {$(".startview h2").css("opacity", "1");}, 1000);
				setTimeout(function() {$(".start_button_container").addClass("start_button_show");}, 1500);

		} catch(e) {
			alert(e);
		}
	},
	
	process: function() {
	},	
		
	mouseDown: function(event) {
		this.panning = true;
		swipe.start(event);
	},
	
	mouseUp: function(event) {
		swipe.end();
		this.panning = false;
	},
	
	mouseMove: function(event) {
		swipe.move(event);
	},

	mouseWheel: function(dt) {
	},
	
	clear: function() {
		
	},

	pause: function() {
		this.paused = true;
	},

	resume: function() {
		this.paused = false;
	}
}